import React, { useCallback } from 'react';
import clsx from 'clsx';
import ComponentWrapperRHF from './ComponentWrapperRHF';

interface Props {
  name: string;
  id: string;
  value: string;
  label?: string;
}

export const RadioRhf = ({ ...props }: Props) => {
  return (
    // @ts-ignore
    <ComponentWrapperRHF {...props}>
      <Radio />
    </ComponentWrapperRHF>
  );
};

export const Radio = ({ label, name, id, value, checked, onChange, isError, ...props }) => {
  const handleChange = useCallback(() => onChange(value), [onChange, value]);
  return (
    <label
      htmlFor={id}
      className={clsx('flex items-center cursor-pointer', props.labelClassName || 'focus-within:ring')}
    >
      <input type="radio" {...props} onClick={handleChange} id={id} className="hidden" />
      <span
        className={clsx(
          'flex justify-center items-center h-5 w-5 rounded-full border border-blue-80 bg-white',
          props.checkboxClassName || 'border-gray-default'
        )}
      >
        {checked === value && (
          <span className={clsx('block rounded-full h-3 w-3', props.activeCheckBoxClassName || 'bg-blue-80')} />
        )}
      </span>
      <span className="font-effra ml-2">{label}</span>
    </label>
  );
};
